import React from "react";
import "../Styles/Csr.css";

const CSR = () => {
  return (

    <>

     <div className="CSR-image">
        {/* <img src="./corporate/CSR.png " alt="" /> */}
        <img src="./projects/csr.jpg " alt="" />
      </div>

    <section className="csr-section">
      <div className="csr-container">

        <h1 className="csr-title">
          CORPORATE SOCIAL RESPONSIBILITY
        </h1>

        <h2 className="csr-subtitle">Food Distribution</h2>

        <p className="csr-desc">
          In a heartfelt initiative to support the underprivileged, Swastika
          Foundation organized a food distribution drive where volunteers came
          together to serve freshly packed wholesome meals to people in need.
        </p>

        <div className="csr-gallery">
          <div className="csr-card">
            <img src="/images/CSR/F1.webp" alt="Food Distribution 1" />
          </div>

          <div className="csr-card">
            <img src="/images/CSR/F2.webp" alt="Food Distribution 2" />
          </div>

          <div className="csr-card">
            <img src="/images/CSR/F3.webp" alt="Food Distribution 3" />
          </div>
        </div>



        <h2 className="csr-subtitle">Education</h2>

        <p className="csr-desc">
        As part of its commitment to education and community development, Swastika Infra, in collaboration with Round Table India, proudly inaugurated newly constructed classrooms under the Freedom Through Education initiative. This project, implemented at Mahatma Gandhi Government School, is a transformative step towards creating better learning environments for children in rural and underserved communities.
        </p>

        <div className="csr-gallery">
          <div className="csr-card">
            <img src="/images/CSR/E1.webp" alt="Food Distribution 1" />
          </div>

          <div className="csr-card">
            <img src="/images/CSR/E2.webp" alt="Food Distribution 2" />
          </div>

          <div className="csr-card">
            <img src="/images/CSR/E3.webp" alt="Food Distribution 3" />
          </div>
        </div>
        <p className="csr-desc">In addition to our other initiatives, we are proud to support the higher education of deserving and underprivileged students by sponsoring their academic fees through Agarwal Shiksha Samiti.  </p>


        <h2 className="csr-subtitle">Health</h2>

        <p className="csr-desc">
         For the betterment of individual and community health, we are proud to support various healthcare initiatives through BMCHRC (Bhagwan Mahaveer Cancer Hospital & Research Centre). Through this, we aim to promote accessible and quality healthcare, raise health awareness, and provide medical assistance to those in need, contributing to the overall well-being of society.
        </p>

       

      </div>
    </section>
    </>
  );
};

export default CSR;

